/* src/course_approvals/cards/CourseApprovalCard/styles.js */

export default theme => ({
  paper: {
    height: theme.spacing.unit * 44,
    overflow: 'auto',
  },
  key: {
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
  },
});



// WEBPACK FOOTER //
// ./src/modules/course_approvals/cards/CourseApprovalCard/styles.js